/* This file is only used in V2 */

export const COUNTRY_MAP = {
  SG: {
    code: 'SG',
    name: 'Singapore',
    currency: {
      symbol: 'S$',
      code: 'SGD',
      defaultText: 'S$0.00',
    },
  },
  ID: {
    code: 'ID',
    name: 'Indonesia',
    currency: {
      symbol: 'Rp',
      code: 'IDR',
      defaultText: 'Rp0.000',
    },
  },
  TH: {
    code: 'TH',
    name: 'Thailand',
    currency: {
      symbol: '',
      code: 'THB',
      defaultText: '0.000',
    },
  },
  PH: {
    code: 'PH',
    name: 'Philippines',
    currency: {
      symbol: '',
      code: 'PHP',
      defaultText: '0.000',
    },
  },
  VN: {
    code: 'VN',
    name: 'Vietnam',
    currency: {
      symbol: 'đ',
      code: 'VND',
      defaultText: '0.000đ',
    },
  },
  MY: {
    code: 'MY',
    name: 'Malaysia',
    currency: {
      symbol: 'RM',
      code: 'MYR',
      defaultText: 'RM0.000',
    },
  },
  MM: {
    code: 'MM',
    name: 'Myanmar',
    currency: {
      symbol: 'K',
      code: 'MMK',
      defaultText: 'K0.000',
    },
  },
};

export const CURRENCY_CODE_TO_ZERO_QUOTE = Object.keys(COUNTRY_MAP).reduce(
  (acc, countryCode) => {
    acc[COUNTRY_MAP[countryCode].currency.code] =
      COUNTRY_MAP[countryCode].currency.defaultText;
    return acc;
  },
  {},
);

export const PARCEL_CATEGORY = {
  SG: [1, 2, 3, 4, 5, 6, 7],
  ID: [1, 2, 3, 4, 5, 6, 7],
  TH: [1, 2, 3, 4, 5, 6, 7],
  PH: [1, 2, 3, 4, 5, 6, 7],
  VN: [2, 3, 4, 5, 7],
  MY: [1, 2, 3, 4, 5, 6, 7],
  MM: [1, 2, 3, 4, 5, 6, 7],
  KH: [1, 2, 3, 4, 5, 6, 7],
};

// `Others` category, if cannot find correct config for country
export const DEFAULT_PARCEL_CATEGORY = [7];
